import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { Route } from 'model';
import { RouteMap } from './RouteMap';
import { searchRoutes } from 'components/SearchUtils';
import { ManPage } from 'components/ManPage/ManPage';

export function FavouriteRoutes({ routes }: { routes: Route[] }): JSX.Element {
  const [searchText, setSearchText] = useState('');
  const filtered = searchText.trim() === '' ? routes : searchRoutes(routes, searchText);

  return (
    <ManPage
      name="routes"
      manual="Trails & Tracks"
      sections={[
        { heading: 'NAME', body: 'routes - running and hiking trails' },
        {
          heading: 'SEARCH',
          body: (
            <input
              type="text"
              className="man-input"
              placeholder="name, location, tag..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          )
        },
        {
          heading: 'ENTRIES',
          body:
            filtered.length === 0 ? (
              `No routes found matching "${searchText}"`
            ) : (
              <>
                {filtered.map((route) => (
                  <div key={route.id} style={{ marginBottom: 16 }}>
                    <div>
                      <span className="man-sub">
                        <Link to={`/routes/${route.id}`}>{route.name}</Link>
                      </span>
                      {` -- ${route.location}`}
                    </div>
                    <div style={{ display: 'flex', gap: 12, marginTop: 6 }}>
                      <div style={{ width: 180, flexShrink: 0 }}>
                        <RouteMap gpxFile={route.gpxFile} mini />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div>{route.description}</div>
                        {route.tags && route.tags.length > 0 && <div>[{route.tags.join(', ')}]</div>}
                        <div style={{ marginTop: 6 }}>
                          <a className="man-btn" href={route.gpxFile} download>
                            download .gpx
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )
        }
      ]}
    />
  );
}
